import { Button, Form, Input, message, Upload } from "antd";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import BackBtn from "../../components/Common/backBtn";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import MainconternLayout from "../../components/Layout/MainconternLayout";
import SucessModal from "../../components/Modal/SucessModal";

const DeliveryAppTrainingCentreForm = () => {
  const { id } = useParams();
  const location = useLocation();

  const isViewMode = location.pathname.includes("-view");
  const isEditMode = location.pathname.includes("-edit");
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [success, setSuccess] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (id) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}delivery-app-training-centre/get/${id}`,
        )
        .then((res) => {
          form.setFieldsValue({
            title: res.data.title || "",
            url: res.data.url || "",
          });

          if (res.data.thumbnail_img) {
            const fullImageUrl = `${process.env.REACT_APP_API_URL}${res.data.thumbnail_img}`;
            setThumbnailFile(null);
            setThumbnailPreview(fullImageUrl);
            form.setFieldsValue({ thumbnail_img: fullImageUrl });
          }
        })
        .catch(() => message.error("Error fetching data"));
    } else {
      form.resetFields();
    }
  }, [id, form]);

  const onFinish = (values) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("url", values.url);

    if (!id && !thumbnailFile) {
      message.error("Thumbnail is required");
      return;
    }
    if (thumbnailFile instanceof File) {
      formData.append("thumbnail", thumbnailFile);
    }

    const apiUrl = id
      ? `${process.env.REACT_APP_API_URL}delivery-app-training-centre/update/${id}`
      : `${process.env.REACT_APP_API_URL}delivery-app-training-centre/create`;

    const method = id ? "PATCH" : "POST";

    axios({
      url: apiUrl,
      method,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(() => setSuccess(true))
      .catch((err) => {
        console.error(err);
        if (err.response && err.response.data && err.response.data.message) {
          message.error(`Image ${err.response.data.message}`);
        } else {
          message.error("Action failed");
        }
      });
  };

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Delivery App Training Centre",
        link: "/delivery-app-training-centre",
      },
      { text: "Add New Video", link: "" },
    ],
    [],
  );

  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex flex-column pb-2 flex-wrap justify-content-start gap-4">
            <AntdBreadcrumbs
              className="w-75 healthsyMasterBreadCrumbs"
              breadcrumbsList={breadcrumbsList}
            />
            <BackBtn navigatePath="/delivery-app-training-centre" />
          </div>
        }
        footer={<></>}
      >
        <div className="healtharticle-container healthsyContainer mt-4">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            className="carr-dep-form"
            initialValues={{
              title: "",
              url: "",
              thumbnail: "",
            }}
          >
            <div className="row car-dep-form">
              <div className="col-4">
                <Form.Item
                  label={
                    <span style={{ color: "#4B4853" }}>
                      Title <span className="star">*</span>
                    </span>
                  }
                  name="title"
                  rules={[{ required: true, message: "Please enter title." }]}
                >
                  <Input
                    className="form-control w-75"
                    disabled={isViewMode}
                    placeholder="Enter video title"
                  />
                </Form.Item>
              </div>

              <div className="col-4">
                <Form.Item
                  label={
                    <span style={{ color: "#4B4853" }}>
                      URL <span className="star">*</span>
                    </span>
                  }
                  name="url"
                  rules={[
                    { required: true, message: "Please enter URL." },
                    { type: "url", message: "Please enter a valid URL." },
                  ]}
                >
                  {isEditMode || isViewMode ? (
                    <TextArea
                      rows={2}
                      className="form-control w-75"
                      disabled={isViewMode}
                      placeholder="Enter video URL"
                    />
                  ) : (
                    <Input
                      className="form-control w-75"
                      disabled={isViewMode}
                      placeholder="Enter video URL"
                    />
                  )}
                </Form.Item>
              </div>
            </div>
            <div className="col-4">
              <Form.Item
                label={
                  <span style={{ color: "#4B4853" }}>
                    Thumbnail <span className="star">*</span>
                  </span>
                }
                name="thumbnail_img"
                rules={[
                  {
                    required: !isViewMode,
                    message: "Please upload a thumbnail.",
                  },
                ]}
              >
                {isViewMode ? (
                  <img
                    src={thumbnailPreview}
                    alt="thumbnail_img"
                    style={{
                      width: "100px",
                      height: "100px",
                    }}
                  />
                ) : (
                  <>
                    {thumbnailPreview && (
                      <img
                        src={thumbnailPreview}
                        alt="thumbnail_img"
                        style={{
                          width: "100px",
                          height: "100px",
                          marginBottom: "10px",
                        }}
                      />
                    )}
                    <Upload
                      beforeUpload={(file) => {
                        setThumbnailFile(file);
                        setThumbnailPreview(URL.createObjectURL(file));
                        form.setFieldsValue({ thumbnail_img: file });
                        return false;
                      }}
                      fileList={
                        thumbnailFile && thumbnailFile instanceof File
                          ? [
                              {
                                uid: "-1",
                                name: thumbnailFile.name || "thumbnail_img",
                                status: "done",
                                url: thumbnailPreview,
                              },
                            ]
                          : []
                      }
                      maxCount={1}
                    >
                      <Button>Click to Upload</Button>
                    </Upload>
                  </>
                )}
              </Form.Item>
            </div>
            {!isViewMode && (
              <div className="car-dep-form-button">
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginTop: "5%" }}
                >
                  {id ? "Update" : "Submit"}
                </Button>
              </div>
            )}
          </Form>
        </div>
      </MainconternLayout>

      {success && (
        <SucessModal
          page={"/delivery-app-training-centre"}
          name="Video"
          post={isEditMode ? "updated" : "posted"}
        />
      )}
    </>
  );
};

export default DeliveryAppTrainingCentreForm;
